// src/lib/greetings.js

export function getDynamicGreeting(name) {
  const hour = new Date().getHours();

  const morningGreetings = [
    `Good morning, ${name}. Here's to a productive start.`,
    `Wishing you a smooth and successful morning, ${name}.`,
    `Morning, ${name}. Let's make steady progress today.`,
  ];

  const afternoonGreetings = [
    `Good afternoon, ${name}. Hope your objectives are on track.`,
    `Checking in, ${name}—keep the momentum going.`,
    `Afternoon, ${name}. Stay focused; you're doing well.`,
  ];

  const eveningGreetings = [
    `Good evening, ${name}. Hope your day wrapped up smoothly.`,
    `Evening, ${name}. A job well done deserves quiet clarity.`,
    `You've earned the evening wind-down, ${name}.`,
  ];

  const lateNightGreetings = [
    `Working late, ${name}? Make sure to take breaks.`,
    `Still at it, ${name}? Diligence doesn’t go unnoticed.`,
    `Night hours can be your edge, ${name}—stay sharp.`,
  ];

  let options = [];

  if (hour >= 5 && hour < 12) {
    options = morningGreetings;
  } else if (hour >= 12 && hour < 17) {
    options = afternoonGreetings;
  } else if (hour >= 17 && hour < 22) {
    options = eveningGreetings;
  } else {
    options = lateNightGreetings;
  }

  return options[Math.floor(Math.random() * options.length)];
}
